import { ScheduleServiceLocation } from './schedule-service';

export const modifyLocations = Object.freeze({
	'schedule-service': new ScheduleServiceLocation()
});

export const listOfAllowedModificationLocation = Object.keys(modifyLocations);
